export default "__VITE_ASSET__Bju28$Jg__"